/* Types */
import { StatesContainer } from '@/types/mapServices'

/**
 * Состояния модуля карты
 */
export const STATE_OF_MAP: StatesContainer = {
  loading: 'pending',
  loaded: 'loaded',
  error: 'error',
}
